export const messages_cy = {
    nameEmpty: "Поље за име не може бити празно.",
    emailEmpty: "Поље за имејл адресу не може бити празно.",
    emailNotValid: "Имејл адреса није валидна, молимо Вас да унесете одговарајућу имејл адресу.",
    locationEmpty: "Поље за локацију не може бити празно.",
    profileSaved: "Профилни подаци снимљени.",
    profilePic: "Профилна слика снимљена.",
    addToFavorites:"Успешно сте додали у омиљене",
    removeFromFavorites:"Успешно сте додали у омиљене"
};


// WEBPACK FOOTER //
// ./src/constants/messages_cy.js